/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.settings.integration.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api'
])

.controller('SettingsIntegrationController', [
  '$rootScope',
  '$scope',
  '$state', 
  'ApiService', 
  function(
    $rootScope,
    $scope,
    $state, 
    ApiService
  ) {

    $scope.settingsIntegration = {

      state: $state,
      model: "Your spankin new application.settings.integration view!",

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Salesforce Integration'
        });
      },

      isTabActive: function(name) {
        return (this.state.current.name === name);
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.settingsIntegration.init();

}]);